/* oxlint-disable typescript/no-unused-vars */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from 'shared/types/redux';
import { updateProjectConfig as updateProjectConfigService } from 'shared/services/updateProjectConfig';
import { showAlert } from 'shared/slices/admin/alert';
import { EAlert } from 'shared/types/alert';

type TUpdateProjectConfigParams = {
  id: number;
  config: object;
};

/* istanbul ignore next */
export const updateProjectConfig = createAsyncThunk<Boolean, TUpdateProjectConfigParams, IThunkApi>(
  'projects/update',
  async ({ id, config }, { extra: context, dispatch, rejectWithValue }) => {
    try {
      const isUpdated = await updateProjectConfigService(context, { id, config: JSON.stringify(config) });

      if (isUpdated) {
        dispatch(showAlert({ message: 'Проект сохранен', type: EAlert.Info }));
      } else {
        dispatch(showAlert({ message: 'Проект не сохранен', type: EAlert.Error }));
      }

      return isUpdated;
    } catch (_) {
      dispatch(showAlert({ message: 'Проект не сохранен', type: EAlert.Error }));

      return rejectWithValue(false);
    }
  },
  {
    /**
     * Можно предотвратить вызов thunk-а через специальный объект с условием
     * (полезно, например, в случаях, если идет загрузка и надо предотвратить повторный запрос)
     */
    // condition: (params, _api) => {
    //   /**
    //    * В api есть стейт и extra
    //    *
    //    * сonst { getState, extra } = api;
    //    */
    //   const { getState } = _api;
    //   const {
    //     demo: { test },
    //   } = getState();
    //   return test;
    // },
  },
);
